import './login.scss';
import InputKMQ from "../../components/UI/Input/InputKMQ";
import {ChangeEvent, KeyboardEventHandler, useContext, useEffect, useState} from "react";
import ButtonKMQ from "../../components/UI/Button/ButtonKMQ";
import {useLogin} from "../../api/login/useLogin";
import {UserContext} from "../../hooks/Context/UserContext";
import {useNavigate} from "react-router-dom";
import {useToken} from "../../hooks/jwt/useToken";
import {object, string, ValidationError} from "yup";
import Loading from "../../components/UI/Loading/Loading";
import {WarningCircle} from '@phosphor-icons/react';
import IdentityProviders from './identity_providers';
import MaintenanceBanner from "../../components/Maintenance/MaintenanceBanner";



const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [user, setUser] = useContext(UserContext);
  const {mutate, isError, data, isSuccess, isPending} = useLogin();
  const {setTokens} = useToken();
  const [validationError, setValidationError] = useState<boolean>(false);

  

  let loginSchema = object({
    email: string().email().min(2).required(),
    password: string().min(2).required()
  });

  const handleSubmit = async () => {
    try {
      await loginSchema.validate({email, password});
      setUser({});
      mutate({email, password})
      setValidationError(false);
    } catch (e) {
      setValidationError(true);
    }
  }
  const onKeyDown: KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (event.keyCode === 13) {
      if (email.length > 2 && password.length > 2) {
        handleSubmit();
      }
    }
  }

  useEffect(() => {
    if (isSuccess && data?.data) {
      if (data?.data?.mfa_required) {
        setUser({email: ''});
        localStorage.setItem('user-email', email);
        navigate('/login/verification-code')
      } else {
        localStorage.removeItem('portfolio_id');
        localStorage.removeItem('marketplace_user');
        localStorage.removeItem('basic_info');
        setUser({
          ...user,
        });
        setTokens({
          accessToken: data?.data?.access,
          refreshToken: data?.data?.refresh
        })
        localStorage.setItem('refresh', data?.data?.refresh)
        navigate('/');
      }
    }
  }, [isSuccess, data])

  return <div>
    <Loading loading={isPending}/>
    <div className={'login-form'}>
      <MaintenanceBanner/>
      <div className={'login-form-title'}>
        Log in
      </div>
      {(validationError || isError) ?
        <p className='login-form-error'><span><WarningCircle size={20}/></span> Invalid Credentials. Please try again.
        </p> : ''}
      <InputKMQ
        value={email}
        onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
        type={'text'}
        placeholder={'Enter email'}
        label={'Email'}
        onKeyDown={onKeyDown}
      />
      <div className={'login-form-password-wrap'}>
        <div
          className={'login-form-password-wrap-link'}
          onClick={() => navigate('/login/forgot-password')}
        >
          Forgot password?
        </div>
        <InputKMQ
          value={password}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
          type={'password'}
          placeholder={'Enter password'}
          label={'Password'}
          passwordShowIcon
          onKeyDown={onKeyDown}
        />
      </div>

      <div className={'login-form-sign-up'}>
        {'New user? '}
        <span className={'login-form-sign-up-link'} onClick={() => navigate('/login/sign-up')}>
        Sign up
      </span>
      </div>
      <div className={'login-form-footer'}>
        <ButtonKMQ onClick={handleSubmit}
                   disabled={!(email.length > 2 && password.length > 2)}>
          Continue
        </ButtonKMQ>
      </div>
      <div>
        <IdentityProviders/>
      </div>
    </div>
  </div>
}

export default Login;